<script setup lang="ts">
import { StackLayout } from '@/components/Layouts'
import TechnicianAnnouncements from './Technician/TechnicianAnnouncements.vue'
import TechnicianWidgets from './Technician/TechnicianWidgets.vue'
</script>

<template>
    <StackLayout direction="column" :gap="16">
        <TechnicianAnnouncements />
        <TechnicianWidgets />
    </StackLayout>
</template>
